(function ($) {
  $(function () {
    const $search = $('.sidebar-search');
    const $searchWrapper = $search.find('.sidebar-search__sidebar-wrapper');
    const $input = $search.find('.sidebar-search__input');

    $input.on('input', function () {
      const value = $(this).val().toLowerCase();
      const $items = $search.find('.sidebar-search__result-item');

      if (!value) {
        $items.addClass('active');
        const $numberOfResults = $search.find(
          '.sidebar-search__results .sidebar-search__result-item.active'
        ).length;
        $search.find('.sidebar-search__result-count span').text($numberOfResults);
        return;
      }

      const pattern = value.split('').join('.*');
      const regex = new RegExp(pattern, 'i');

      $items.each(function () {
        const text = $(this).text().toLowerCase();
        if (regex.test(text)) {
          $(this).addClass('active');
        } else {
          $(this).removeClass('active');
        }
      });
      const $numberOfResults = $search.find(
        '.sidebar-search__results .sidebar-search__result-item.active'
      ).length;
      $search.find('.sidebar-search__result-count span').text($numberOfResults);
    });

    $search.find('.sidebar-search__reset').on('click', function () {
      $input.val('').trigger('input').focus();
    });
    const $numberOfResults = $search.find(
      '.sidebar-search__results .sidebar-search__result-item:visible'
    ).length;
    $search.find('.sidebar-search__result-count span').text($numberOfResults);

    $search.find('.sidebar-search__close').on('click', function () {
      $searchWrapper.removeClass('active');
    });
    $search.find('.sidebar-search__overlay').on('click', function () {
      $searchWrapper.removeClass('active');
    });
    $search.find('.sidebar-search__button').on('click', function () {
      $searchWrapper.addClass('active');
      $input.focus();
    });
  });
})(jQuery);
